import React, { SVGProps } from 'react'
const SvgEmptyStateChart = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={82}
    height={80}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <rect
      width={14.911}
      height={4.103}
      fill="#EAEBF1"
      rx={1.207}
      transform="matrix(-1 0 0 1 78.41 15)"
    />
    <rect
      width={34.911}
      height={4.103}
      fill="#EAEBF1"
      rx={1.207}
      transform="matrix(-1 0 0 1 78.41 60)"
    />
    <rect
      width={24.911}
      height={4.103}
      fill="#EAEBF1"
      rx={1.207}
      transform="matrix(-1 0 0 1 25.41 52)"
    />
    <g filter="url(#EmptyStateChart_svg__a)">
      <ellipse cx={42} cy={39} fill="#fff" rx={34.5} ry={35} />
    </g>
    <g filter="url(#EmptyStateChart_svg__b)">
      <path
        fill="url(#EmptyStateChart_svg__c)"
        d="M10 43.69c0-.696.564-1.26 1.26-1.26h10.08c.696 0 1.26.564 1.26 1.26V67H10V43.69Z"
      />
    </g>
    <g filter="url(#EmptyStateChart_svg__d)">
      <path
        fill="url(#EmptyStateChart_svg__e)"
        d="M27.01 24.79c0-.696.564-1.26 1.26-1.26h10.08c.696 0 1.26.564 1.26 1.26V67h-12.6V24.79Z"
      />
    </g>
    <g filter="url(#EmptyStateChart_svg__f)">
      <path
        fill="url(#EmptyStateChart_svg__g)"
        d="M43.39 34.87c0-.696.564-1.26 1.26-1.26h10.08c.696 0 1.26.564 1.26 1.26V67h-12.6V34.87Z"
      />
    </g>
    <g filter="url(#EmptyStateChart_svg__h)">
      <path
        fill="url(#EmptyStateChart_svg__i)"
        d="M60.4 15.34c0-.696.564-1.26 1.26-1.26h10.08c.696 0 1.26.564 1.26 1.26V67H60.4V15.34Z"
      />
    </g>
    <defs>
      <filter
        id="EmptyStateChart_svg__a"
        width={79}
        height={80}
        x={2.5}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={2.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7466_1374"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_7466_1374"
          result="shape"
        />
      </filter>
      <filter
        id="EmptyStateChart_svg__b"
        width={18.9}
        height={30.87}
        x={6.85}
        y={39.91}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.63} />
        <feGaussianBlur stdDeviation={1.575} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0862449 0 0 0 0 0.369598 0 0 0 0 0.799349 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7466_1374"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_7466_1374"
          result="shape"
        />
      </filter>
      <filter
        id="EmptyStateChart_svg__d"
        width={18.9}
        height={49.77}
        x={23.86}
        y={21.01}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.63} />
        <feGaussianBlur stdDeviation={1.575} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0862449 0 0 0 0 0.369598 0 0 0 0 0.799349 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7466_1374"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_7466_1374"
          result="shape"
        />
      </filter>
      <filter
        id="EmptyStateChart_svg__f"
        width={17.64}
        height={38.43}
        x={40.87}
        y={33.61}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2.52} />
        <feGaussianBlur stdDeviation={1.26} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0641434 0 0 0 0 0.0416223 0 0 0 0 0.766569 0 0 0 0.5 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7466_1374"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_7466_1374"
          result="shape"
        />
      </filter>
      <filter
        id="EmptyStateChart_svg__h"
        width={18.9}
        height={59.22}
        x={57.25}
        y={11.56}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.63} />
        <feGaussianBlur stdDeviation={1.575} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0862449 0 0 0 0 0.369598 0 0 0 0 0.799349 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7466_1374"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_7466_1374"
          result="shape"
        />
      </filter>
      <linearGradient
        id="EmptyStateChart_svg__c"
        x1={8.6}
        x2={31.798}
        y1={68.72}
        y2={57.331}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#406DE1" />
        <stop offset={1} stopColor="#5ED7C6" />
      </linearGradient>
      <linearGradient
        id="EmptyStateChart_svg__e"
        x1={25.61}
        x2={52.341}
        y1={70.043}
        y2={62.625}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#406DE1" />
        <stop offset={1} stopColor="#5ED7C6" />
      </linearGradient>
      <linearGradient
        id="EmptyStateChart_svg__g"
        x1={55.99}
        x2={76.103}
        y1={27.61}
        y2={40.203}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4E3EDF" />
        <stop offset={1} stopColor="#9C92FB" />
      </linearGradient>
      <linearGradient
        id="EmptyStateChart_svg__i"
        x1={59}
        x2={86.367}
        y1={70.704}
        y2={64.466}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#406DE1" />
        <stop offset={1} stopColor="#5ED7C6" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgEmptyStateChart
